import React from "react";
import styled from "styled-components";
import { row } from "@ui/components/layout";

interface QuizResultIconProps extends React.HTMLAttributes<HTMLDivElement> {
	score: number;
}
export const QuizResultIcon: React.FC<QuizResultIconProps> = ({ score, ...htmlProps }) => {
	return (
		<Container {...htmlProps}>
			<div>{score >= 50 ? "🎉" : "😔"}</div>
		</Container>
	);
};

const Container = styled.div`
	width: 69px;
	height: 69px;
	border-radius: 35px;
	box-shadow: 0 22px 34px 0 rgba(0, 0, 0, 0.1);
	background-color: ${({ theme }) => theme.colors.white};
	${row(0, "center", "center")};
	font-size: 2.25rem;
	line-height: 2.25rem;

	> div {
		margin-top: 3px;
	}
`;
